import React from "react";
import { Button, Tooltip, Whisper, Notification } from "rsuite";
import qs from "query-string";
import { saveAs } from "file-saver";
import axios from "../../../utilities/axios";

interface SaleExportState {
    loading: boolean;
}

export class SaleExportBrowserlize extends React.Component<any, SaleExportState> {
    state: SaleExportState = {
        loading: false,
    };

    onExport = () => {
        this.setState({ loading: true });

        const params = qs.parse(this.props.history.location.search);
        const exportParams: any = {};
        for (const key in params) {
            if (key === "page" || key === "perPage") {
                continue;
            }
            if (key === "sortColumn") {
                exportParams.sortBy = params[key];
                continue;
            }
            exportParams[key] = params[key];
        }

        axios
            .get("/api/v1/sales/export-excel", { params: exportParams })
            .then((response) => {
                const { downloadUrl, errors } = response.data;
                if (downloadUrl) {
                    return axios.get(downloadUrl, { responseType: "blob" }).then((fileResponse) => {
                        saveAs(fileResponse.data, downloadUrl.split("/").pop());
                    });
                } else {
                    Notification.error({
                        title: "Erro!",
                        description: errors?.join(", ") ?? "Não foi possível gerar o relatório em excel!",
                        placement: "bottomEnd",
                    });
                }
            })
            .catch(() => {
                Notification.error({
                    title: "Erro!",
                    description: "Não foi possível gerar o relatório em excel!",
                    placement: "bottomEnd",
                });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    };

    render(): React.ReactNode {
        return (
            <Whisper trigger="hover" placement="bottom" speaker={<Tooltip placement="bottom">Exportar para Excel</Tooltip>}>
                <Button color="green" className="mr-2" loading={this.state.loading} onClick={this.onExport}>
                    <i className="fas fa-fw fa-file-excel"></i>
                </Button>
            </Whisper>
        );
    }
}
